import { v4 as uuidv4 } from "uuid";
import { FormConfiguration } from "../../shared/crud/form";
import { Checkbox } from "../../shared/widgets/checkbox";
import { messages } from "../messages";
import { EngineGuestDataEntity } from "./engineGuestData.entity";

export function buildFormConfiguration(): FormConfiguration<EngineGuestDataEntity> {
  return {
    __fieldOrder: [
      "bookingFormCountry",
      "bookingFormPhone",
      "bookingFormDni",
      "bookingFormBirthDate",
      "bookingFormAddress",
      "bookingFormCity",
      "bookingFormPostalCode",
      "bookingFormRepeatEmail",
      "bookingFormArrivalTime",
      "bookingFormNewsletter",
      "bookingFormAllGuestsData",
      "*",
    ],
    __useProtoStyleArrays: true,
    id: {
      default: () => uuidv4(),
      hidden: true,
    },

    bookingFormCountry: {
      messages: {
        label: messages.bookingFormCountry,
      },
      widget: Checkbox,
      default: () => false,
    },
    bookingFormPhone: {
      messages: {
        label: messages.bookingFormPhone,
      },
      widget: Checkbox,
      default: () => false,
    },
    bookingFormDni: {
      messages: {
        label: messages.bookingFormDni,
      },
      widget: Checkbox,
      default: () => false,
    },
    bookingFormBirthDate: {
      messages: {
        label: messages.bookingFormBirthDate,
      },
      widget: Checkbox,
      default: () => false,
    },
    bookingFormAddress: {
      messages: {
        label: messages.bookingFormAddress,
      },
      widget: Checkbox,
      default: () => false,
    },
    bookingFormCity: {
      messages: {
        label: messages.bookingFormCity,
      },
      widget: Checkbox,
      default: () => false,
    },
    bookingFormPostalCode: {
      messages: {
        label: messages.bookingFormPostalCode,
      },
      widget: Checkbox,
      default: () => false,
    },
    bookingFormRepeatEmail: {
      messages: {
        label: messages.bookingFormRepeatEmail,
      },
      widget: Checkbox,
      default: () => false,
    },
    bookingFormArrivalTime: {
      messages: {
        label: messages.bookingFormArrivalTime,
      },
      widget: Checkbox,
      default: () => false,
    },
    bookingFormNewsletter: {
      messages: {
        label: messages.bookingFormNewsletter,
      },
      widget: Checkbox,
      default: () => false,
    },
    bookingFormAllGuestsData: {
      messages: {
        label: messages.bookingFormAllGuestsData,
      },
      widget: Checkbox,
      default: () => false,
    },
  };
}
